
import { useCookies } from 'react-cookie'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { userStateData } from '../../data/userStateData'
import './style.scss'

interface DashboardHeaderProps {
	title: string
}

function DashboardHeader({title}: DashboardHeaderProps) {

	const [cookies, setCookie, removeCookie] = useCookies(['userData'])

	const logoutClickHandler = () => {
		userStateData.logOut()
		removeCookie("userData",{
			path: "/"
		})
		window.location.replace(PAGE_URLS.SEARCH)
	}

	return (
		<div className='dashboard-header-wrap'>
			<div className='dashboard-header-title'>
				{title}
			</div>
			{userStateData.getUserIconUrl() &&
				<>
					<a
						className='dashboard-header-profile-img-wrap'
						href={PAGE_URLS.DASHBOARD_CUSTOMER}
					>
						<img 
							className='dashboard-header-profile-img'
							src={userStateData.getUserIconUrl()}
							alt='Profile'
						/>
					</a>
					<div
						className='user-popup-button dashboard-header-profile-logout-button'
						// href={'/'}
						onClick={() => logoutClickHandler()}
					>Logout</div>
				</>
			}
		</div>
	)
}

export default DashboardHeader